import { useState } from "react";
import { useHistory } from "react-router-dom";
import useUrlState from "@ahooksjs/use-url-state";

import customers from "configs/customers";
import GenericHeader from "../../../components/GenericHeader/GenericHeader";
import GenericTable from "../../../components/GenericTable/GenericTable";

import placeholderPic from "../../../assets/no_data_x.gif";
import { useApiHook } from "providers/ApiProvider";

import Box from "@mui/material/Box";

const CustomersTableView = () => {
  const history = useHistory();

  const [selectedRows, setSelectedRows] = useState([]);
  const [queryParams, setQueryParams] = useUrlState({
    // q: undefined,
    page: 0,
    size: 10,
    // sortBy: "id",
    // sortDirection: "desc",
  });

  // const [searchQuery, setSearchQuery] = useState(
  //   localStorage.getItem("searchQuery") || ""
  // );

  // const permissionChecker = usePermissionChecker();

  const query = {
    // q: searchQuery ?? "",
    page: Number(queryParams.page) + 1,
    size: queryParams.size,
    // sortBy: queryParams.sortBy ?? "id",
    // sortDirection: queryParams.sortDirection ?? "desc",
  };

  const customerData = useApiHook("Customers", "getAllResources", { query });

  // const handleSearch = (value: string) => {
  //   localStorage.setItem("searchQuery", value);
  //   setSearchQuery(value);

  //   if (queryParams.q !== value) {
  //     setQueryParams({ q: value, page: 0 });
  //   } else {
  //     setQueryParams({ q: value });
  //   }
  // };

  // const deleteCustomer = () => {
  //   if (!permissionChecker("delete-customer", true)) return;

  //   setLoading(true);

  //   customersClient
  //     .deleteManyResource({ data: selectedRows })
  //     .then(() => customerData.refresh())
  //     .finally(() => setLoading(false));
  // };

  const navigateToAddPage = () => {
    history.push(`customers/add`);
  };

  const rowTriggerAction = (row: any) => {
    history.push(`customers/${row?.id}`);
  };

  const handlePageChange = (e: any, value: any) => {
    setQueryParams({ page: value });
  };

  const handleRowsChange = (e: { target: { value: string } }) => {
    setQueryParams({ page: 0, size: parseInt(e.target.value) });
  };

  const handleRowSelectionChange = (data: any) => {
    setSelectedRows(data);
  };

  // const onColumnSort = (c: any) => {
  //   if (queryParams.sortBy === c) {
  //     setQueryParams((s) => ({
  //       sortDirection: s.sortDirection === "asc" ? "desc" : "asc",
  //     }));
  //   } else {
  //     setQueryParams({ sortBy: c, sortDirection: "asc" });
  //   }
  // };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        maxHeight: "100vh",
        overflow: "scroll",
      }}
    >
      <GenericHeader
        // onSearch={handleSearch}
        addResourceHandler={navigateToAddPage}
        // deleteResourceHandler={deleteCustomer}
        selectedRows={selectedRows}
        model="customer"
      />
      <div className="p-4">
        <h2 className="mb-4">Customers</h2>
        <GenericTable
          showCheckbox={false}
          frontendPagination={true}
          list={customerData?.data?.data ? customerData?.data?.data : []}
          totalCount={customerData?.data?.data?.length || 0}
          onSelectedChange={handleRowSelectionChange}
          selectedRows={selectedRows}
          page={Number(queryParams.page)}
          loading={customerData.loading}
          rowsPerPage={Number(queryParams.size)}
          onRowsChange={handleRowsChange}
          onPageChange={handlePageChange}
          image={placeholderPic}
          tableConfig={customers}
          model="customer"
          passRow={rowTriggerAction}
          // columnSort={queryParams.sortBy}
          // columnSortDir={queryParams.sortDirection}
          // onColumnSort={onColumnSort}
        />
      </div>
    </Box>
  );
};

export default CustomersTableView;
